import { CurrencyCode } from './API'

export enum OrganisationFormat {
  GiftVouchers = 'voucher',
  SpecialOffers = 'special_offers',
  Tickets = 'ticket',
}

export interface ICategoryResponse {
  id: number
  parent: number
  title: string
  order: number
  imageUrl: string
  manualOrderOnly?: boolean
}

export enum Font {
  Serif = 'serif',
  SansSerif = 'sans-serif',
}

export enum FontSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum Role {
  SuperAdmin = 'admin',
  SubSuperAdmin = 'sub-admin',
  OrganisationAdmin = 'organisation-admin',
  OrganisationUser = 'organisation-user',
  OrganisationRedeemer = 'organisation-redeem',
  Dispatch = 'admin-deliveries',
}

export enum AdminRole {
  SuperAdmin = 'admin',
  SubSuperAdmin = 'sub-admin',
  Dispatch = 'admin-deliveries',
}

export enum OrgRole {
  OrganisationAdmin = 'organisation-admin',
  OrganisationUser = 'organisation-user',
  OrganisationRedeemer = 'organisation-redeem',
}

export type User = {
  email: string
  role: Role
}

export enum SubCategoryFormat {
  Row = 'row',
  Grid = 'grid',
  List = 'list',
}

export interface IOrganisationResponse {
  id: number
  status: string
  code: string
  name: string
  format: OrganisationFormat
  displayName: string
  addressLineOne: string
  addressLineTwo: string
  addressTown: string
  addressCounty: string
  addressPostcode: string
  telephone: string
  type: string
  emailAddress: string
  url: string
  logoId: string
  font: Font
  categoriesEnabled: boolean
  categoryImages: boolean
  currencyCode: CurrencyCode
  colourHighlight: string
  colourTextOnHighlight: string
  imageUrl: string
  headerImageUrl: string
  headerImageFileId: number
  redemptionDetails: string
  termsAndConditions: string
  colourHeaderText: string
  colourBodyText: string
  colourPriceText: string
  emailDelivery: boolean
  postDelivery: boolean
  purchaserTerms: string
  introductoryText: string
  colourPageBackground: string
  colourTextOnBackground: string
  colourHeaderBackground: string
  textOnBackgroundSize: FontSize
  transparentIframe: boolean
  embedUrl: string
  newPurchaseUI?: boolean
  hasIndividuals?: boolean
  hasPartialRedemption?: boolean
  fbPixelId: string
  gaTrackingId: string
  minimumCommission?: number
  licenceFee?: number
  commissionFee?: number
  voucherBodyText: string
  voucherBottomBackground: string
  voucherBottomText: string
  voucherTopBackground: string
  voucherTopText: string
  voucherFont: Font
  outstandingFields: string[]
  subCategoryFormat?: SubCategoryFormat
}
